import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "store";
import {
  addCandidate,
  clearAllCandidates,
  removeCandidate,
} from "../../../../../../../store/steps/stepFiveSlice";
import { apiService } from "../../../../../services/apiService";

const useCandidates = ({ hasMore }) => {
  const dispatch = useDispatch();
  const { assessmentId } = useParams();
  const [page, setPage] = useState<number>(0);
  const [hasMoreItems, setHasMoreItems] = useState<boolean>(hasMore);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const candidates = useSelector(
    (state: RootState) => state.stepFive.candidates
  );

  const getMoreCandidates = async (newPage: number) => {
    setIsLoading(true);
    try {
      const data = await apiService.getCandidates({
        assessmentId,
        page: newPage + 1,
        limit: 10,
      });
      setHasMoreItems(data.hasMoreResults);
      dispatch(clearAllCandidates());
      data.assessments.forEach((user) => {
        dispatch(addCandidate({ name: user.name, email: user.email }));
      });
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPage(newPage);
    getMoreCandidates(newPage);
  };

  const handleDelete = (index: number) => {
    dispatch(removeCandidate(index));
  };

  return {
    error,
    page,
    isLoading,
    candidates,
    hasMoreItems,
    handlePageChange,
    handleDelete,
  };
};

export default useCandidates;
